






























































import { JournalEntry } from "../../models/JournalEntry";
import EmployeSelect from "../../core/Forms/EmployeSelect.vue";
import DateInput from "../../core/Forms/DateInput.vue";
import JournalObjectSelect from "../../core/Forms/JournalObjectSelect.vue";
import FileUploader from "../../core/Forms/FileUploader.vue";
import { Contact } from "../../models/Contact";
import ContactSelect from "../../core/Forms/ContactSelect.vue";
import HtmlTextareaInput from "../../core/Forms/HtmlTextareaInput.vue";

export default {
    name: "JournalEntryModalEdit",
    components: {
        HtmlTextareaInput,
        ContactSelect,
        FileUploader,
        JournalObjectSelect,
        DateInput,
        EmployeSelect,
    },
    props: {
        entry: JournalEntry,
        parent: JournalEntry,
    },
    data() {
        return {
            availableFiles: [],
            contactSelectFilters: [
                Contact.EType.Copropriete,
                Contact.EType.Bureau,
                Contact.EType.Particulier,
            ],
        };
    },
    created() {
        if (this.parent) {
            this.availableFiles = _.concat(
                this.parent.files,
                this.parent.get_comments_attachments()
            );
        }
    },
    methods: {
        // files
        updateFilesList: function (filesIds: Array<Number>): void {
            this.entry.filesIds = filesIds;
        },
        updatePhotosList: function (photoIds: Array<Number>): void {
            this.entry.photoIds = photoIds;
        },
        onUploadStart: function () {
            this.$emit("files-uploading", true);
        },
        onUploadEnd: function () {
            this.$emit("files-uploading", false);
        },
        isNew(): boolean {
            return !this.notification.id;
        },
        isFolder(): boolean {
            return !this.entry.parent_id;
        },
    },
};
